import Country from '~/Api/Country/Country';
import ApiClient from '~/ApiClient';

export interface Result {
	items: Country[];
}

export default async function findNationalities(client: ApiClient): Promise<Result> {
	const request = await client.fetch('ae-price-referencing/max-price/nationalities');
	const response = await request.json();
	return {
		items: response.items.map((country: { alpha2: string; name: string }) => new Country(country.alpha2, country.name)),
	};
}
